import { useEffect, useState } from "react";
import { PartsType } from "../types/types";

export const useHoverParts = () => {
  const [hoveredPart, setHoveredPart] = useState<PartsType | null>(null);

  useEffect(() => {
    if (!hoveredPart) {
    }
  }, [hoveredPart]);

  const onHoverPartItem = (part: PartsType | null) => {
    setHoveredPart(part);
  };

  return { onHoverPartItem, hoveredPart };
};
